import { ToastProvider } from "./ToastProvider";
import { AuthProvider } from "./AuthProvider";

export const UtilsProvider = ({ children}) => {
  return (
    <ToastProvider>
      <AuthProvider>
        {children}
      </AuthProvider>
    </ToastProvider>
  );
};
